import { useState, useEffect } from "react";
import { isIOS, isMobile } from "react-device-detect";

export const useIsIphone = () => {
  const [isIphone, setIsIphone] = useState<boolean>();

  useEffect(() => {
    setIsIphone(isMobile && isIOS);
  }, []);

  return isIphone;
};
